import {
  defaultBreakpoints,
  MediaList,
  DEFAULT_MEDIA,
  createBreakpoints,
} from '@semcore/base-components';

export default defaultBreakpoints;

export { MediaList, DEFAULT_MEDIA, createBreakpoints };
